import { FC } from 'react';

import { Space } from 'app/components/space/Space';
import { Icon } from 'app/components/icon/Icon';

export const Contacts: FC = () => {
  return (
    <Space gap='10px' alignItems='center'>
      <a href='mailto:burdukowskystas@gmail.com' title='E-Mail'>
        <Icon name='mail' />
      </a>
      <a
        href='https://github.com/burdukowsky'
        target='_blank'
        rel='noreferrer'
        title='Github'
      >
        <Icon name='github' />
      </a>
      <a
        href='https://t.me/stanislav_burdukowsky'
        target='_blank'
        rel='noreferrer'
        title='Telegram'
      >
        <Icon name='telegram' />
      </a>
      <a
        href='https://wa.link/ub5kx9'
        target='_blank'
        rel='noreferrer'
        title='WhatsApp'
      >
        <Icon name='whatsapp' />
      </a>
      {/*<a
        href='https://www.facebook.com/burdukowsky.stas'
        target='_blank'
        rel='noreferrer'
        title='Facebook'
      >
        <Icon name='facebook' />
      </a>
      <a
        href='https://x.com/burdukowsky'
        target='_blank'
        rel='noreferrer'
        title='X'
      >
        <Icon name='x' />
      </a>
      <a
        href='https://novosibirsk.hh.ru/resume/fb52b182ff10bd5d370039ed1f5266556e3857'
        target='_blank'
        rel='noreferrer'
        title='Head Hunter'
      >
        <Icon name='hh' />
      </a>
      <a
        href='https://career.habr.com/stas6386778'
        target='_blank'
        rel='noreferrer'
        title='Habr Career'
      >
        <Icon name='habr' />
      </a>
      <a
        href='https://vk.com/stas6386778'
        target='_blank'
        rel='noreferrer'
        title='VK'
      >
        <Icon name='vk' />
      </a>*/}
    </Space>
  );
};
